import React, { useState, useEffect, useRef, useCallback } from "react"
import { useTranslation } from "react-i18next"
import { cn } from "../lib/utils"
import { Input } from "./ui/input"
import { Search, X } from "lucide-react"
interface SearchInputProps {
 value?: string
 onChange: (value: string) => void
 placeholder?: string
 debounceMs?: number
 className?: string
}

export function SearchInput({
 value: controlledValue,
 onChange,
 placeholder,
 debounceMs = 300,
 className,
}: SearchInputProps) {
 const { t } = useTranslation()
 const resolvedPlaceholder = placeholder ?? t('ui.searchPlaceholder')
 const [localValue, setLocalValue] = useState(controlledValue || "")

 useEffect(() => {
 setLocalValue(controlledValue || "")
 }, [controlledValue])

 const timeoutRef = useRef<NodeJS.Timeout>()
 const debouncedChange = useCallback(
 (val: string) => {
 clearTimeout(timeoutRef.current)
 timeoutRef.current = setTimeout(() => onChange(val), debounceMs)
 },
 [onChange, debounceMs]
 )

 const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
 const val = e.target.value
 setLocalValue(val)
 debouncedChange(val)
 }

 const handleClear = () => {
 setLocalValue("")
 onChange("")
 }

 return (
 <div className={cn("relative", className)}>
 <Search className="absolute start-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground pointer-events-none"/>
 <Input
 value={localValue}
 onChange={handleChange}
 placeholder={resolvedPlaceholder}
 className="ps-9 pe-9"/>
 {localValue && (
 <button
 onClick={handleClear}
 className="absolute end-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors">
 <X className="h-4 w-4"/>
 </button>
 )}
 </div>
 )
}
